<template>
  <component class="chevron" :is="chevronType" :color="color" :style="style" />
</template>

<script>
import Down from '@/Scripts/components/shared/svg/Chevron/Assets/ChevronDown.vue';
import DownLight from '@/Scripts/components/shared/svg/Chevron/Assets/ChevronDownLight.vue';
import DownThin from '@/Scripts/components/shared/svg/Chevron/Assets/ChevronDownThin.vue';
import Right from '@/Scripts/components/shared/svg/Chevron/Assets/ChevronRight.vue';
import RightLight from '@/Scripts/components/shared/svg/Chevron/Assets/ChevronRightLight.vue';
import RightThin from '@/Scripts/components/shared/svg/Chevron/Assets/ChevronRightThin.vue';
import Left from '@/Scripts/components/shared/svg/Chevron/Assets/ChevronLeft.vue';
import LeftLight from '@/Scripts/components/shared/svg/Chevron/Assets/ChevronLeftLight.vue';
import LeftThin from '@/Scripts/components/shared/svg/Chevron/Assets/ChevronLeftThin.vue';
import Up from '@/Scripts/components/shared/svg/Chevron/Assets/ChevronUp.vue';
import UpLight from '@/Scripts/components/shared/svg/Chevron/Assets/ChevronUpLight.vue';
import UpThin from '@/Scripts/components/shared/svg/Chevron/Assets/ChevronUpThin.vue';

export default {
  name: 'Chevron',
  components: {
    Down,
    DownLight,
    DownThin,
    Right,
    RightLight,
    RightThin,
    Left,
    LeftLight,
    LeftThin,
    Up,
    UpLight,
    UpThin
  },
  props: {
    color: String,
    size: {
      type: Number,
      default: 16
    },
    direction: {
      type: String,
      default: 'down',
      validator: value => ['down', 'up', 'left', 'right'].includes(value)
    },
    thickness: {
      type: String,
      default: '',
      validator: value => ['', 'thin', 'light'].includes(value)
    }
  },
  computed: {
    chevronType () {
      return `${this.captialize(this.direction)}${this.captialize(
        this.thickness
      )}`;
    },
    style () {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`
      };
    }
  },
  methods: {
    captialize (string) {
      string = string.toLowerCase();
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }
};
</script>

<style lang="scss">
svg.chevron {
  width: 16px;
  height: 16px;
}
</style>
